/**
 * @param {string} date YYYY-MM-DD
 * @returns number in Unix Timestamp
 * @description Конвертирует дату в Unix Timestamp
 */
export const toUTS = (date) => Math.floor(new Date(date).getTime() / 1000);
